import React, { useContext, useState, useEffect, useRef } from 'react'
import moment from 'moment'
import { Button } from '@mui/material'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import ProductCommonContext from '@/product/context/common/commonContext'
import {
    mapData,
    dateFormatFunction,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '@/product/common/components'
import CustomCommonContext from '@/custom/context/common/commonContext'
import Loaders from '@/product/components/molecules/Loaders'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import AlertContext from '@/product/context/alert/alertContext'
import {
    initialFunction,
    validationFunction,
    editValue,
} from '@/product/components/species/dynamic/common/FieldFunction'
import ProductContext from '@/product/context/product/productContext'

import ItemPropsList from '@/product/components/species/dynamic/common/Item'
import { useTranslation } from 'react-i18next'
import CustomDialog from '@/product/components/organisms/Dialog'
import Cryptos from '@/product/common/cryptos'
import settingContext from '@/custom/context/setting/settingContext'
import NotesContext from '@/product/context/notes/notesContext'
import AuthContext from '@/product/context/auth/authContext'
import AuctionContext from '@/product/context/auction/auctionContext'

const BaseActionPage = (props) => {
    const data = props.data
    const arrayValue = props.arrayValue
    const { t } = useTranslation()
    const notesContext = useContext(NotesContext)
    const { responseStatus, notesManage, clearResponse } = notesContext
    const { alldata_all_dropdown, allLocations, alldisapprovalReason } =
        useContext(CustomCommonContext)
    const auctionContext = useContext(AuctionContext)
    const {
        all_auctions,
        getAllAuctions,
        responseStatus: responseStatusAuction,
        clearResponse: clearResponseAuction,
    } = auctionContext
    const authContext = useContext(AuthContext)
    const { user, isAuthenticated } = authContext
    const [isAuctionFiledUpdate, setIsAuctionFiledUpdate] = useState(false)
    const productContext = useContext(ProductContext)
    const settingContexts = useContext(settingContext)
    const {
        all_global_data,
        getSerialCheck,
        serialCheckDetails,
        clearSerialCheck,
    } = settingContexts
    const alertContext = useContext(AlertContext)
    const { allCountries, allStates, allCities } =
        useContext(ProductCommonContext)
    const { setAlert } = alertContext
    const {
        projectAction,
        single_project,
        getCloseTimeConfiguration,
        project_timing_config,
        getSingleProject,
        responseStatus: responseStatusProduct,
        clearResponse: clearResponseProduct,
    } = productContext
    const [reload, setReload] = useState(false)
    const [valueLoaded, setValueLoaded] = useState(false)
    const [initialValues, setInitialValues] = useState({})
    const [initialEmptyValues, setInitialEmptyValues] = useState({})
    const [calculateFields, setCalculateFields] = useState([])
    const [validationArray, setValidationArray] = useState({})
    const [mapDataValue, setMapDataValue] = useState([])
    const [mapDataValue1, setMapDataValue1] = useState([])
    const [mapDataValue2, setMapDataValue2] = useState([])
    const [serialHabanosField, setSerialHabanosField] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [arrayItemTrigger, SetArrayItemTrigger] = useState(false)
    const [additionalSubmit, setAdditionalSubmit] = useState('')
    const [itemPropsArrayErrors, SetItemPropsArrayErrors] = useState({})
    const [toggleDialogErr, setToggleDialogErr] = useState(false)
    const [disapStatus, setDisapStatus] = useState(false)
    const [escalateStatus, setEscalateStatus] = useState(false)
    const [serialCheckDialog, setSerialCheckDialog] = useState(false)
    const [serialCheckData, setSerialCheckData] = useState(null)

    const onAddItemArrayHandle = (option) => {
        if (formik.values.itemPropStep === 0) {
            SetArrayItemTrigger(true)
        }

        formik.values.itemPropStep += 1
        formik.setFieldValue('itemPropStep', formik.values.itemPropStep)
    }

    const formSubmitFunction = (values, marketStatus) => {
        const value = values
        let tempMapData = mapDataValueRef.current
        value.customdatetime = []
        value.encryptedValues = {}
        tempMapData.map((data) => {
            if (data.type === 'datetime' || data.type === 'date') {
                if (value[data.name]) {
                    value[data.name] = moment(
                        value[data.name],
                        global?.defaultDateTimeFormat
                            ? global.defaultDateTimeFormat
                            : 'MM-DD-YYYY h:mm a'
                    ).format()
                    value.customdatetime.push(data.name)
                }
            }
            if (data.type === 'hiddenMask' && value[data.name]) {
                const encKey = data.name
                const encValue = Cryptos.encrypt(value[data.name])
                value[encKey] = encValue
                value.encryptedValues[encKey] = encValue
            }
        })

        if (data?.status === 'use') {
            value.id = 0
        }

        if (value.title?.trim() === '') {
            setAlert('Title is a Required field', 'error')
        } else {
            const status = marketStatus ? marketStatus : value.market_status
            props.actionFunction(value, status)
        }
    }

    const formik = useFormik({
        initialValues: initialValues,
        validateOnBlur: false,
        validationSchema: Yup.object().shape({ ...validationArray }, [
            'auction',
            'buynow',
        ]),
        enableReinitialize: true,
        onSubmit: (values) => {
            // let val = alldata_all_dropdown.filter(
            //     (item) => item.id == values.year
            // )

            let yearsTitle =
                values?.year == 'Unknown Year'
                    ? values?.description_year
                    : values.year
            const titleYearPart = yearsTitle ? ' ' + yearsTitle : ''
            // values.title =
            //     values.brand +
            //     ' ' +
            //     values.vitola +
            //     ' ' +
            //     yearsTitle +
            //     ' ' +
            //     values.packaginggit
            values.serial_number = values?.serial_number
                ? values.serial_number.trim()
                : ''

            if (values?.number_of_cigars_remaining) {
                values.title =
                    values.brand +
                    ' ' +
                    values.vitola +
                    titleYearPart +
                    ' ' +
                    values?.number_of_cigars_remaining +
                    ' ' +
                    'cigars remaining'
            } else {
                values.title =
                    values.brand + ' ' + values.vitola + titleYearPart
            }
            if (!values.check_box_code_valid) {
                delete values.check_box_code_valid
            }
            if (!values.serial_number_valid) {
                delete values.serial_number_valid
            }

            values.product_approved = true

            if (!values?.id) {
                values.updated_at = new Date()
            }

            if (
                subCountryOptions()?.length ==
                values?.delivery_not_available?.length
            ) {
                setAlert(
                    'Please check delivery not available country field',
                    'error'
                )
            } else {
                formSubmitFunction(values)
            }
        },
    })

    useEffect(() => {
        if (props.handleMapDataValue) {
            props.handleMapDataValue(mapDataValue)
        }
    }, [mapDataValue, mapDataValue1, mapDataValue2])

    useEffect(() => {
        if (serialCheckDetails?.HSA) {
            setSerialCheckData(serialCheckDetails)
            setSerialCheckDialog(true)
            clearSerialCheck()
        }
    }, [serialCheckDetails])

    useEffect(() => {
        if (isAuthenticated) {
            getAllAuctions(
                {
                    page: 1,
                    limit: 50,
                    order: '',
                    orderby: '',
                    auctionTimeFilter: true,
                    filters: {
                        market_status: {
                            value: 'open',
                            type: 'in',
                            field: 'ac.market_status',
                        },
                    },
                },
                'assignAuctions'
            )
        }
    }, [isAuthenticated])

    useEffect(() => {
        if (props.additionalFormikUpdate) {
            if (props.setrprice) {
                formik.values.rprice = formik.values.sprice
                props.additionalFormikUpdate(formik.values)
            } else {
                props.additionalFormikUpdate(formik.values)
            }
        }
    }, [formik.values, props?.setrprice])

    const subStateOptions = (data) => {
        if (formik?.values?.country) {
            let valueDrop = allStates
                .filter(
                    (state) =>
                        (formik.values.auction_country
                            ? formik.values.auction_country
                                ? formik.values.auction_country.indexOf(
                                      state.countryCode
                                  ) !== -1
                                : global.defaultCountry.indexOf(
                                      state.countryCode
                                  ) !== -1
                            : formik.values.country
                            ? formik.values.country.indexOf(
                                  state.countryCode
                              ) !== -1
                            : global.defaultCountry.indexOf(
                                  state.countryCode
                              ) !== -1) &&
                        global.ignoreStates.indexOf(state.isoCode) === -1
                )
                .map((buscat) => {
                    let busCategoryChanged = {}
                    busCategoryChanged.show = buscat.name
                    busCategoryChanged.value = buscat.isoCode
                    return busCategoryChanged
                })

            return valueDrop
        }
        return []
    }

    const subCountryOptions = (data) => {
        let val = alldata_all_dropdown?.filter(
            (data) =>
                data.variable == 'delivery_to' &&
                data.id == formik?.values?.delivery_to
        )
        if (val[0]?.description === 'EU Countries Only') {
            return allCountries
                .filter((country) => country?.Territory_EU === 1) // Assuming 'currency' field indicates git
                .map((country) => ({
                    show: country.name,
                    value: country.isoCode,
                }))
        } else {
            return allCountries
                .filter(
                    (country) =>
                        global.ignoreCountry.indexOf(country.isoCode) === -1
                )
                .map((country) => ({
                    show: country.name,
                    value: country.isoCode,
                }))
        }
    }

    const subCityOptions = (data) => {
        let valueDrop = allCities
            .filter((state) =>
                formik.values?.country && formik.values?.state
                    ? formik.values.country.indexOf(state.countryCode) !== -1 &&
                      formik.values.state.indexOf(state.stateCode) !== -1
                    : formik.values.state
                    ? global.defaultCountry.indexOf(state.countryCode) !== -1 &&
                      formik.values.state.indexOf(state.stateCode) !== -1
                    : false
            )
            .map((buscat) => {
                let busCategoryChanged = {}
                busCategoryChanged.show = buscat.name
                busCategoryChanged.value = buscat.name
                return busCategoryChanged
            })

        return valueDrop
    }
    const cigarOptions = (field, filterValue, filtername, data) => {
        let valueDrop = all_global_data?.records
            ?.filter((item) => item[field].trimEnd() === filterValue)
            .map((buscat) => buscat[filtername])
            // Remove case-insensitive duplicates
            .filter(
                (value, index, self) =>
                    self.findIndex(
                        (v) => v.toLowerCase() === value.toLowerCase()
                    ) === index
            )
            // Sort alphabetically (case-insensitive)
            .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
            .map((value) => {
                const trimmed = value.trimEnd()
                return {
                    description: trimmed,
                    show: trimmed,
                    value: trimmed,
                }
            })

        return valueDrop
    }

    const cigarCountryOptions = (
        field1,
        field2,
        filterValue1,
        filterValue2,
        filtername,
        data
    ) => {
        let valueDrop = all_global_data?.records
            ?.filter(
                (item) =>
                    item[field1].trimEnd() === filterValue1 &&
                    item[field2].trimEnd() === filterValue2
            )
            .map((buscat) => buscat[filtername])
            // Remove case-insensitive duplicates
            .filter(
                (value, index, self) =>
                    self.findIndex(
                        (v) => v.toLowerCase() === value.toLowerCase()
                    ) === index
            )
            // Sort alphabetically (case-insensitive)
            .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
            .map((value) => {
                const trimmed = value.trimEnd()
                return {
                    description: trimmed,
                    show: trimmed,
                    value: trimmed,
                }
            })

        return valueDrop
    }

    const cigarBrandOptions = (
        field1,
        field2,
        field3,
        filterValue1,
        filterValue2,
        filterValue3,
        filtername,
        data
    ) => {
        let valueDrop = all_global_data?.records
            ?.filter(
                (item) =>
                    item[field1]?.trimEnd() === filterValue1 &&
                    item[field2]?.trimEnd() === filterValue2 &&
                    item[field3]?.trimEnd() === filterValue3
            )
            .map((buscat) => buscat[filtername])
            // Use filter to remove case-insensitive duplicates
            .filter(
                (value, index, self) =>
                    self.findIndex(
                        (v) => v?.toLowerCase() === value?.toLowerCase()
                    ) === index
            )
            .sort((a, b) => a?.toLowerCase().localeCompare(b?.toLowerCase()))
            .map((value) => ({
                description: value?.trimEnd(),
                show: value?.trimEnd(),
                value: value?.trimEnd(),
            }))

        return valueDrop
    }

    const cigarOptionsJoin = (
        field1,
        field2,
        field3,
        field4,
        filterValue1,
        filterValue2,
        filterValue3,
        filterValue4,
        filtername1,
        filtername2,
        data
    ) => {
        return all_global_data?.records
            ?.filter(
                (item) =>
                    item[field1]?.trimEnd() === filterValue1 &&
                    item[field2]?.trimEnd() === filterValue2 &&
                    item[field3]?.trimEnd() === filterValue3 &&
                    item[field4]?.trimEnd() === filterValue4
            )
            .map((item) => {
                const combinedValue = `${item[filtername1] ?? ''} ${
                    item[filtername2] ?? ''
                }`

                return {
                    description: combinedValue?.trimEnd(),
                    show: combinedValue?.trimEnd(),
                    value: combinedValue?.trimEnd(),
                }
            })
            .filter(
                (value, index, self) =>
                    self.findIndex(
                        (v) =>
                            v.value?.toLowerCase() ===
                            value.value?.toLowerCase()
                    ) === index
            )
            .sort((a, b) =>
                a.value?.toLowerCase().localeCompare(b.value?.toLowerCase())
            )
    }

    const packingOptions = (
        field1,
        field2,
        field3,
        field4,
        field5,
        field6,
        filterValue1,
        filterValue2,
        filterValue3,
        filterValue4,
        filterValue5,
        filtername,
        data
    ) => {
        return all_global_data?.records
            ?.filter(
                (item) =>
                    `${item[field5] ?? ''} ${item[field6] ?? ''}`.trimEnd() ===
                        filterValue5 &&
                    item[field1]?.trimEnd() === filterValue1 &&
                    item[field2]?.trimEnd() === filterValue2 &&
                    item[field3]?.trimEnd() === filterValue3 &&
                    item[field4]?.trimEnd() === filterValue4
            )
            .map((item) => ({
                description: item[filtername] ?? '',
                show: item[filtername] ?? '',
                value: item[filtername] ?? '',
            }))
            .filter(
                (value, index, self) =>
                    self.findIndex(
                        (v) =>
                            v.value?.toLowerCase() ===
                            value.value?.toLowerCase()
                    ) === index
            )
            .sort((a, b) =>
                a.value?.toLowerCase().localeCompare(b.value?.toLowerCase())
            )
    }

    const yearOptions = (
        field1,
        field2,
        field3,
        field4,
        field5,
        field6,
        field7,
        filterValue1,
        filterValue2,
        filterValue3,
        filterValue4,
        filterValue5,
        filterValue6
    ) => {
        // Step 1: Check if all_global_data and records are available
        if (
            !all_global_data ||
            !all_global_data.records ||
            all_global_data.records.length === 0
        ) {
            return [] // Return empty array if no data is available
        }

        // Step 2: Filter records based on the provided values
        const filteredRecords = all_global_data.records.filter(
            (item) =>
                `${item[field5] ?? ''} ${item[field6] ?? ''}`.trimEnd() ===
                    filterValue5?.trimEnd() &&
                item[field1]?.trimEnd() === filterValue1?.trimEnd() &&
                item[field2]?.trimEnd() === filterValue2?.trimEnd() &&
                item[field3]?.trimEnd() === filterValue3?.trimEnd() &&
                item[field4]?.trimEnd() === filterValue4?.trimEnd() &&
                item[field7]?.trimEnd() === filterValue6?.trimEnd()
        )

        // Step 3: Check if any records were found, else return an empty array
        if (filteredRecords.length === 0) {
            return [] // No records found, return empty array
        }

        // Step 4: Assuming only one record is returned, get the first match
        const filteredRecord = filteredRecords[0]
        const year = filteredRecord.YearStart
        let endsYear = ''

        // Check if the year starts with 'c'
        if (String(year)?.startsWith('c')) {
            endsYear = parseInt(String(year).substring(1), 10) + 1
        } else {
            endsYear = year
        }

        // Step 5: Generate an array of years between `yearStart` and `yearEnd`
        const yearEnd = filteredRecord.YearEnd
        const yearStart = endsYear

        const currentYear = new Date().getFullYear()
        const effectiveYearEnd = yearEnd === 0 ? currentYear : yearEnd

        const years = []
        for (let year = yearStart; year <= effectiveYearEnd; year++) {
            years.push(year)
        }

        // Step 6: Map years to the desired object structure
        const yearOptionsList = years.map((year) => ({
            description: year?.toString(),
            show: year?.toString(),
            value: year?.toString(),
        }))

        // Step 7: Add "Unknown Year" option at the top of the list
        const unknownYearOption = {
            description: t('Unknown Year'),
            show: t('Unknown Year'),
            value: 'Unknown Year',
        }

        // Return the array with "Unknown Year" at the top
        return [unknownYearOption, ...yearOptionsList]
    }

    const yearOptionsFilter = (
        field1,
        field2,
        field3,
        field4,
        field5,
        field6,
        field7,
        filterValue1,
        filterValue2,
        filterValue3,
        filterValue4,
        filterValue5,
        filterValue6
    ) => {
        return all_global_data?.records
            ?.filter(
                (item) =>
                    `${item[field5]} ${item[field6]}`.trimEnd() ===
                        filterValue5 &&
                    item[field1].trim() === filterValue1.trim() &&
                    item[field2].trim() === filterValue2.trim() &&
                    item[field3].trim() === filterValue3.trim() &&
                    item[field4].trim() === filterValue4.trim() &&
                    item[field7].trim() === filterValue6.trim()
            )
            .filter(
                (value, index, self) =>
                    self.findIndex(
                        (v) =>
                            v.value?.toLowerCase() ===
                            value.value?.toLowerCase()
                    ) === index
            )
    }

    useEffect(() => {
        if (
            props?.editValue?.record?.market_status === 'draft' &&
            data?.status === 'edit'
        ) {
            if (project_timing_config.date_added) {
                formik.setFieldValue(
                    'date_added',
                    dateTimeFormatFunction(
                        project_timing_config.date_added,
                        true
                    )
                )
            }
            if (project_timing_config.date_closed) {
                formik.setFieldValue(
                    'date_closed',
                    dateTimeFormatFunction(
                        project_timing_config.date_closed,
                        true
                    )
                )
            }
        }
    }, [props?.editValue?.record?.market_status, project_timing_config])

    useEffect(() => {
        const inputDate = formik.values?.date_added

        if (!formik?.values?.auctionid && !isAuctionFiledUpdate) {
            if (inputDate) {
                const parsed = moment(inputDate, 'DD-MM-YYYY h:mm a') // or ISO if it's ISO

                if (parsed.isValid()) {
                    const newDate = parsed.add(72, 'hours').toDate()
                    const formatted = dateTimeFormatFunction(
                        newDate,
                        false,
                        'DD-MM-YYYY h:mm a'
                    )
                    formik.setFieldValue('date_closed', formatted)
                } else {
                    console.warn('Invalid date_added format:', inputDate)
                }
            }
        } else {
            setIsAuctionFiledUpdate(false)
        }
    }, [formik.values.date_added])

    const subLevelOptions = (data) => {
        let valueDrop = []

        valueDrop = alldata_all_dropdown
            .filter((subcat) => {
                if (
                    formik.values[data.sub_field] &&
                    parseInt(subcat.level, 10) === parseInt(data.sub_level, 10)
                ) {
                    if (
                        parseInt(subcat.active, 10) === 1 ||
                        (formik.values[data.name] &&
                            formik.values[data.name] === subcat.id)
                    ) {
                        if (data.diff_value) {
                            let mainId = alldata_all_dropdown.filter(
                                (item) =>
                                    item.value === formik.values[data.sub_field]
                            )[0]

                            return (
                                parseInt(subcat.level_id, 10) ===
                                parseInt(mainId?.id, 10)
                            )
                        } else {
                            return (
                                parseInt(formik.values[data.sub_field], 10) ===
                                parseInt(subcat.level_id, 10)
                            )
                        }
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            })
            .sort((a, b) => a.show_order - b.show_order)
            .map((subcat) => {
                let subCategoryChanged = {}
                subCategoryChanged.show = subcat.description
                subCategoryChanged.value = data.diff_value
                    ? subcat.value
                    : subcat.id
                return subCategoryChanged
            })
        if (valueDrop.length) {
            return valueDrop
        } else {
            return valueDrop
        }
    }

    const mapDataValueRef = useRef(mapDataValue)
    const errorArray = useRef([])
    useEffect(() => {
        mapDataValueRef.current = mapDataValue
    })

    const [firstTimeEdit, setFirstTimeEdit] = useState(true)

    useEffect(() => {
        if (
            formik?.values?.delivery_to &&
            (props?.editValue?.record?.delivery_to !=
                formik?.values?.delivery_to ||
                !firstTimeEdit)
        ) {
            setFirstTimeEdit(false)

            let val = alldata_all_dropdown?.filter(
                (data) =>
                    data.variable == 'delivery_to' &&
                    data.id == formik?.values?.delivery_to
            )

            if (val[0]?.description == 'All') {
                let countrySelectedAll = allCountries.map(
                    (country) => country.isoCode
                )

                formik.setFieldValue('delivery_available_country', [])
                formik.setFieldValue('delivery_not_available', [])
                formik.setFieldValue(
                    'delivery_available_country',
                    countrySelectedAll
                )
                formik.values.delivery_available_country = countrySelectedAll
            }

            if (val[0]?.description === 'EU Countries Only') {
                formik.setFieldValue('delivery_available_country', [])
                formik.setFieldValue('delivery_not_available', [])
                let countrySelectedEU = allCountries
                    .filter((country) => country?.Territory_EU === 1)
                    .map((country) => country.isoCode)

                formik.setFieldValue(
                    'delivery_available_country',
                    countrySelectedEU
                )
            }
            if (val[0]?.description === 'Allowed Delivery Preferences') {
                formik.setFieldValue('delivery_available_country', [])
                formik.setFieldValue('delivery_not_available', [])
            }
            if (val[0]?.description === 'Not Allowed Delivery Preferences') {
                formik.setFieldValue('delivery_available_country', [])
            }
        } else if (!props?.editValue?.record?.delivery_to) {
            let val = alldata_all_dropdown?.filter(
                (data) =>
                    data.variable == 'delivery_to' &&
                    data.id == formik?.values?.delivery_to
            )

            if (val[0]?.description === 'All') {
                let countrySelectedAll = allCountries.map(
                    (country) => country.isoCode
                )

                formik.setFieldValue(
                    'delivery_available_country',
                    countrySelectedAll
                )
            }
        }
    }, [formik?.values?.delivery_to, allCountries])

    useEffect(() => {
        setValueLoaded(false)
        setIsLoading(true)
        setInitialValues({})
        setInitialEmptyValues({})
        setMapDataValue([])
        setMapDataValue1([])
        setMapDataValue2([])
        let custom = props.customInitialValues

        if (arrayValue?.length) {
            let mapValueArray = arrayValue
            let { tempMapData, show, calculateValues } = initialFunction(
                mapValueArray,
                alldata_all_dropdown,
                subLevelOptions,
                allCountries,
                subStateOptions,
                subCityOptions,
                allLocations
            )

            setInitialValues({ ...show, ...custom })
            setInitialEmptyValues({ ...show, ...custom })
            setMapDataValue(tempMapData)

            if (props.customInBetween) {
                // Find the serial_number_habanos_valid field
                const serialFieldIndex = tempMapData.findIndex(
                    (item) => item.name === 'serial_number_habanos_valid'
                )
                const firstHalf = tempMapData.slice(0, serialFieldIndex)
                const serialField = tempMapData.slice(
                    serialFieldIndex,
                    serialFieldIndex + 1
                )
                const secondHalf = tempMapData.slice(serialFieldIndex + 1)
                setMapDataValue1(firstHalf)
                setSerialHabanosField(serialField)
                setMapDataValue2(secondHalf)
            }

            // setCalculateFields(calculateValues)

            setTimeout(() => {
                if (tempMapData.length) {
                    setValueLoaded(true)
                    setIsLoading(false)
                    setReload(!reload)
                }
            }, 1000)
        }
    }, [arrayValue])

    useEffect(() => {
        if (mapDataValueRef.current.length) {
            let tempMapData = mapDataValueRef.current
            tempMapData.map((data) => {
                if (
                    data.type === 'select' &&
                    parseInt(data.sub_select, 10) === 1
                ) {
                    if (parseInt(data.sub_level, 10) > 0) {
                        data.options = subLevelOptions(data)
                    }
                }

                if (data?.name == 'auctionid') {
                    let val = all_auctions?.records?.length || 0

                    data.class = `${val ? 'col-sm-12 col-12' : 'd-none'}`
                }
                if (data?.name == 'state') {
                    let val = subStateOptions('state')

                    data.class = `col-sm-6 col-12 ${
                        val?.length > 0 ? '' : 'd-none'
                    }`

                    data.options = subStateOptions('state')
                }
                if (data.type === 'select' && data.name === 'city') {
                    data.options = subCityOptions(data)
                }

                if (data.type === 'select' && data.name === 'maker_country') {
                    data.options = cigarOptions(
                        'Maker',
                        formik.values.maker,
                        'MakerCountry',
                        data
                    )
                }

                if (data.type === 'select' && data.name === 'cigar_source') {
                    let datas = all_global_data?.cigar_source || []

                    // Check if the current formik value exists in the data
                    let exists = datas?.some(
                        (el) =>
                            el?.source_value === formik?.values?.cigar_source
                    )

                    // If not, add it to the beginning of the data array
                    if (
                        !exists &&
                        formik?.values?.cigar_source &&
                        data?.options?.length
                    ) {
                        data.options.unshift({
                            description: formik?.values?.cigar_source,
                            show: formik?.values?.cigar_source,
                            value: formik?.values?.cigar_source,
                        })
                    }
                }
                if (data.type === 'select' && data.name === 'cigar_country') {
                    data.options = cigarCountryOptions(
                        'Maker',
                        'MakerCountry',
                        formik.values.maker,
                        formik.values.maker_country,
                        'CigarCountry',
                        data
                    )
                }
                if (data.type === 'select' && data.name === 'brand') {
                    data.options = cigarBrandOptions(
                        'Maker',
                        'MakerCountry',
                        'CigarCountry',
                        formik.values.maker,
                        formik.values.maker_country,
                        formik.values.cigar_country,
                        'Marca',
                        data
                    )
                }
                if (data.type === 'select' && data.name === 'vitola') {
                    data.options = cigarOptionsJoin(
                        'Maker',
                        'MakerCountry',
                        'CigarCountry',
                        'Marca',
                        formik.values.maker,
                        formik.values.maker_country,
                        formik.values.cigar_country,
                        formik.values.brand,
                        'VitoladeSalida',
                        'SpecialReleaseName',
                        data
                    )
                }
                if (data.type === 'select' && data.name === 'packaging') {
                    data.options = packingOptions(
                        'Maker',
                        'MakerCountry',
                        'CigarCountry',
                        'Marca',
                        'VitoladeSalida',
                        'SpecialReleaseName',
                        formik.values.maker,
                        formik.values.maker_country,
                        formik.values.cigar_country,
                        formik.values.brand,
                        formik.values.vitola,
                        'Packaging',
                        data
                    )
                }
                if (data.name === 'year' && data.type === 'select') {
                    data.options = yearOptions(
                        'Maker',
                        'MakerCountry',
                        'CigarCountry',
                        'Marca',
                        'VitoladeSalida',
                        'SpecialReleaseName',
                        'Packaging',
                        formik.values.maker,
                        formik.values.maker_country,
                        formik.values.cigar_country,
                        formik.values.brand,
                        formik.values.vitola,
                        formik.values.packaging
                    )
                }
                if (
                    data.name === 'current_number_of_cigars_in_box'
                    // data.name === 'year'
                ) {
                    let filterData = yearOptionsFilter(
                        'Maker',
                        'MakerCountry',
                        'CigarCountry',
                        'Marca',
                        'VitoladeSalida',
                        'SpecialReleaseName',
                        'Packaging',
                        formik.values.maker,
                        formik.values.maker_country,
                        formik.values.cigar_country,
                        formik.values.brand,
                        formik.values.vitola,
                        formik.values.packaging
                    )

                    formik.values.current_number_of_cigars_in_box =
                        filterData[0]?.NumberOfCigarsInBox
                    formik.values.type_release = filterData[0]?.TypeRelease
                    formik.values.cigar_id = filterData[0]?.id
                    formik.values.ring_gauge = filterData[0]?.RingGauge
                    formik.values.region =
                        filterData[0]?.Region?.length > 0 ? 1 : 0
                    formik.values.year_cigar_discontinued =
                        filterData[0]?.YearCigarDiscontinued?.length > 0 ? 1 : 0
                    formik.values.length = filterData[0]?.Length
                    formik.values.special =
                        filterData[0]?.SpecialReleasename?.length > 0 ? 1 : 0
                    formik.values.uv_image_year =
                        filterData[0]?.First_Year_Of_Seal_UV
                    formik.values.description = filterData[0]?.Description

                    data.disabled = filterData[0]?.NumberOfCigarsInBox
                        ? true
                        : false
                }

                if (data.name === 'delivery_not_available') {
                    data.options = subCountryOptions()
                }

                if (data.name === 'delivery_available_country') {
                    data.options = subCountryOptions()
                }

                if (
                    data.type === 'multiselect' &&
                    parseInt(data.sub_select, 10) === 1
                ) {
                    if (parseInt(data.sub_level, 10) > 0) {
                        data.options = subLevelOptions(data)
                    }
                }
            })
        }
    }, [formik.values, all_global_data, all_auctions])

    useEffect(() => {
        setValidationArray({})

        if (arrayValue?.length) {
            let mapValueArray = arrayValue
            let handle = validationFunction(
                mapValueArray,
                props.customValidation,
                t
            )
            setValidationArray(handle)
        }
    }, [arrayValue, props.customValidation])

    const resetForm = () => {
        setInitialValues(initialEmptyValues)
        if (
            props.customInitialValues &&
            props.customInitialValues.itemPropStep > 0
        ) {
            SetArrayItemTrigger(true)
        } else {
            SetArrayItemTrigger(false)
        }
        setReload(!reload)
    }

    const handleSingleProject = (edit_value) => {
        if (edit_value?.record?.id) {
            const auction = edit_value.record
            let objectPush = editValue(arrayValue, auction)
            if (props.customDynamicInput) {
                objectPush.itemPropStep = objectPush?.multiArrayObject?.length
            }

            setInitialValues(objectPush)
            setReload(!reload)

            if (Object.keys(objectPush).length) {
                setTimeout(() => {
                    SetArrayItemTrigger(true)
                }, 2000)
            }
        }
    }

    const hasRun = useRef(false)

    useEffect(() => {
        if (hasRun.current) return
        hasRun.current = true

        if (
            data?.id &&
            (data?.status === 'edit' ||
                data?.status === 'editTemplate' ||
                data?.status === 'duplicate')
        ) {
            formik.values.id = data?.id
            if (props.permission) {
                formik.values.is_permission_not_required = props.permission
            } else {
                delete formik.values.is_permission_not_required
            }

            props.editFunction({
                id: data.id,
                is_permission_not_required: props.permission || false,
            })
        } else if (data?.status === 'use') {
            formik.values.id = data.id
        } else if (data?.status === 'new') {
            resetForm()
        }
    }, [data?.id])

    useEffect(() => {
        if (
            Object.keys(initialEmptyValues).length !== 0 &&
            (props?.data?.status == 'new' ||
                props?.data?.status == 'newTemplate')
        ) {
            resetForm()
        }
    }, [initialEmptyValues])

    useEffect(() => {
        if (Object.keys(initialEmptyValues).length !== 0) {
            // resetForm()
        }
    }, [])

    const formikAddNotes = useFormik({
        initialValues: {
            notes: '',
            id: 0,
            project_id: 0,
            user_id: 0,
            action: 'addComment',
            uploadimages: '',
        },
        validationSchema: Yup.object({
            notes: Yup.string().required('Required!'),
        }),
        onSubmit: (values) => {
            if (user?.admin_id && values.project_id) {
                values.user_id = user?.admin_id ? user?.admin_id : 0
                values.username = user?.username
                    ? user?.username
                    : user?.emp_firstname + '' + user?.emp_lastname
                notesManage(values, 'addNotes')
                projectAction(
                    { escalate: 1, id: values.project_id },
                    'projectAction'
                )
            }
        },
    })

    // useEffect(() => {
    //     if (
    //         responseStatus?.from === 'addNotesListings' &&
    //         responseStatus?.status === 'success'
    //     ) {
    //         clearResponse()
    //         formikAddNotes.handleReset()
    //         handleEscalateBtn()
    //     }
    // }, [responseStatus])

    useEffect(() => {
        if (
            (data?.id &&
                props?.editValue?.record?.id &&
                (data?.status === 'edit' || data?.status === 'editTemplate')) ||
            data?.status === 'duplicate'
        ) {
            if (
                data?.status === 'edit' &&
                props?.editValue?.record?.market_status === 'draft'
            ) {
                const currentDateTime = moment().format('YYYY-MM-DDTHH:mm:ssZ')

                getCloseTimeConfiguration({
                    current_datetime: currentDateTime,
                    auctionid: props?.editValue?.record?.auctionid,
                })
            }
            handleSingleProject(props.editValue)
            setReload(!reload)
        } else if (data?.status === 'new') {
            if (props?.editValue?.record?.id) {
                handleSingleProject(props.editValue)
                setReload(!reload)
            } else {
                resetForm()
            }
        }
    }, [props.editValue])

    useEffect(() => {
        if (
            data?.status === 'edit' &&
            props?.editValue?.record?.market_status === 'draft' &&
            formik?.values?.id &&
            (formik?.values?.auctionid || formik?.values?.auctionid == 0)
        ) {
            const currentDateTime = moment().format('YYYY-MM-DDTHH:mm:ssZ')
            getCloseTimeConfiguration({
                current_datetime: currentDateTime,
                auctionid: formik?.values?.auctionid,
            })
            setIsAuctionFiledUpdate(true)
        }
    }, [formik?.values?.auctionid])

    const [lastFocused, setLastFocused] = useState(null)

    useEffect(() => {
        const handleFocus = (e) => {
            if (e.target.tagName === 'INPUT' && e.target.type === 'text') {
                setLastFocused(e.target)
            } else {
                setLastFocused(null)
            }
        }

        document.addEventListener('focusin', handleFocus)
        return () => {
            document.removeEventListener('focusin', handleFocus)
        }
    }, [])

    const formSubmit = (type, status) => {
        setAdditionalSubmit(status)

        if (lastFocused) {
            const name = lastFocused.name
            formik.setFieldValue(name, lastFocused.value)
            formik.setFieldTouched(name, true, true)
        }
        if (formik?.values?.delivery_to) {
            let val = alldata_all_dropdown?.filter(
                (data) =>
                    data.variable == 'delivery_to' &&
                    data.id == formik?.values?.delivery_to
            )
            if (val[0]?.description === 'Not Allowed Delivery Preferences') {
                let countryNotAvailable =
                    formik?.values?.delivery_not_available || []

                let checkIncluedsEu = countryNotAvailable.includes('EU')

                if (checkIncluedsEu) {
                    let countrySelectedEU = allCountries
                        .filter((country) => country?.Territory_EU === 1) // Assuming 'region' indicates EU membership
                        .map((country) => country.isoCode) // Extract only the 'code' property
                    countryNotAvailable = [
                        ...countryNotAvailable,
                        ...countrySelectedEU,
                    ]
                    let countrySelectedAll = allCountries
                        .filter(
                            (country) =>
                                !countryNotAvailable.includes(country.isoCode)
                        ) // Exclude the not available countries
                        .map((country) => country.isoCode) // Get the country codes

                    formik.setFieldValue(
                        'delivery_not_available',
                        countryNotAvailable
                    )

                    formik.setFieldValue(
                        'delivery_available_country',
                        countrySelectedAll
                    )
                } else {
                    let countrySelectedAll = allCountries
                        .filter(
                            (country) =>
                                !countryNotAvailable.includes(country.isoCode)
                        )
                        .map((country) => country.isoCode) // Get the country codes
                    formik.setFieldValue(
                        'delivery_available_country',
                        countrySelectedAll
                    )
                }
            }
            if (val[0]?.description === 'Allowed Delivery Preferences') {
                let countryAvailable =
                    formik?.values?.delivery_available_country || []
                let checkIncluedsEu = countryAvailable.includes('EU')
                if (checkIncluedsEu) {
                    let countrySelectedEU = allCountries
                        .filter((country) => country?.Territory_EU === 1) // Assuming 'region' indicates EU membership
                        .map((country) => country.isoCode) // Extract only the 'code' property
                    countryAvailable = [
                        ...countryAvailable,
                        ...countrySelectedEU,
                    ]

                    formik.setFieldValue(
                        'delivery_available_country',
                        countryAvailable
                    )
                }
            }
        }

        if (status == '') {
            formik.setFieldValue(
                'market_status',
                single_project?.record?.market_status
            )
        } else {
            formik.setFieldValue('market_status', status)
        }

        setTimeout(() => {
            if (type === 'submit' || props.draftValidation) {
                if (props.validationPopup) {
                    errorArray.current = []
                    if (Object.keys(formik.errors).length) {
                        for (const key in formik.errors) {
                            if (formik.errors.hasOwnProperty(key)) {
                                mapDataValue.forEach((e) => {
                                    if (e.name == key)
                                        errorArray.current.push({
                                            ...e,
                                            errorVal: formik.errors[key],
                                        })
                                })
                            }
                        }
                        setToggleDialogErr(true)
                    }
                    formik.submitForm()
                } else {
                    formik.submitForm()
                }
            } else {
                formik.values.title =
                    formik.values.brand +
                    ' ' +
                    formik.values.vitola +
                    ' ' +
                    formik.values.year

                formSubmitFunction(formik.values, status)
            }
        }, 10)
    }

    const dynamicOprator = (data, operator) => {
        let valueTemp = 0
        switch (operator) {
            case '*':
                valueTemp = data.reduce((a, b) => {
                    return formik.values[a] * formik.values[b]
                })
                break
            case '+':
                valueTemp = data.reduce((a, b) => {
                    return Number(formik.values[a]) + Number(formik.values[b])
                })
                break
            case '-':
                valueTemp = data.reduce((a, b) => {
                    return Number(formik.values[a]) - Number(formik.values[b])
                })
                break
            case '/':
                valueTemp = data.reduce((a, b) => {
                    return Number(formik.values[a]) / Number(formik.values[b])
                })
                break
            case '=':
                valueTemp = formik.values[data]
                break
            default:
                break
        }

        return valueTemp
    }
    useEffect(() => {
        if (calculateFields.length) {
            calculateFields.map((buscat) => {
                formik.values[buscat.name] = dynamicOprator(
                    buscat.calculate_value.value,
                    buscat.calculate_value.operator
                )
            })
        }
    }, [formik.values])

    useEffect(() => {
        if (data?.status === 'edit' && data.id && props.changePassword) {
            if (props.empPassword) {
                props.formikPassword.values.id = data?.as_employees_id
                props.formikPassword.values.password = ''
                props.formikPassword.values.confirm_password = ''
            } else {
                props.formikPassword.values.id = data.id
                props.formikPassword.values.new_password = ''
                props.formikPassword.values.confirm_password = ''
            }
        }
    }, [data])

    const changeDialogStatusErr = () => {
        setToggleDialogErr(!toggleDialogErr)
    }

    useEffect(() => {
        if (
            props.populateValidation &&
            validationArray &&
            initialValues &&
            data?.status !== 'edit'
        ) {
            if (Object.keys(props.customValidation).length)
                formik.validateForm().then((errors) => {
                    if (Object.keys(errors).length) {
                        formik.handleSubmit()
                    }
                })
        }
    }, [props.customValidation, validationArray, initialValues, data])

    const formikApprovalSelection = useFormik({
        initialValues: {
            disapproval_reasons: [],
            disapproval_admin_reasons: [],
            id: null,
            market_status: '',
        },
        validationSchema: Yup.object({
            disapproval_reasons: Yup.string().required('Required!'),
        }),
        onSubmit: (values) => {
            values.id = props?.editValue?.record.id
            values.first_name =
                props?.editValue?.record?.as_employees_emp_firstname
            values.username = props?.editValue?.record?.as_employees_username
            values.last_name =
                props?.editValue?.record?.as_employees_emp_lastname
            values.email = props?.editValue?.record?.as_employees_emp_email
            values.market_status = 'reject'
            values.disapproval_admin_reasons = alldisapprovalReason
                ?.filter((el) =>
                    values.disapproval_reasons.includes(el.email_text)
                )
                .map((el) => el.admin_reason_text)
            if (values.id) {
                projectAction(values, 'projectAction')
            }
        },
    })

    const disapprovalField = {
        formik: formikApprovalSelection,
        data: [
            {
                label: 'Disapproval Reasons',
                placeholder: 'Select Disapproval Reasons',
                disablePast: true,
                type: 'multiselect',
                class: `col-12`,
                name: 'disapproval_reasons',
                options: alldisapprovalReason?.map((el) => {
                    return {
                        show: el.admin_reason_text,
                        description: el.admin_reason_text,
                        value: el.email_text,
                    }
                }),
            },
        ],
    }
    const addNotesField = {
        formik: formikAddNotes,
        data: [
            {
                label: 'Notes *',
                placeholder: 'Enter Notes',
                type: 'textarea',
                class: `col-12`,
                name: 'notes',
                rows: 4,
            },
            {
                type: 'uploadDropZone',
                name: 'uploadimages',
                titleText: 'Upload product images',
                innerText: 'Recommended dimensions: 500px * 500px',
                class: 'col-12',
                folder: 'product',
                multiple: false,
                accept: 'image/*',
            },
        ],
    }

    const handleDisapproveBtn = () => {
        setDisapStatus(!disapStatus)
    }
    const handleEscalateBtn = () => {
        setEscalateStatus(!escalateStatus)
    }

    const handleSerialCheckConfirm = async () => {
        if (formik.values.cigar_id && serialCheckData?.Description) {
            formik.setFieldValue('serial_number_habanos_valid', true)
            getSerialCheck({
                serialNumber: formik?.values?.serial_number,
                cigarId: formik.values.cigar_id,
                confirm: true,
                description: serialCheckData?.Description,
                hsa: serialCheckData?.HSA,
            })
            setSerialCheckDialog(false)
            setSerialCheckData(null)
        }
    }

    const handleSerialCheckCancel = () => {
        setSerialCheckDialog(false)
        setSerialCheckData(null)
    }

    return (
        <>
            {isLoading ? (
                <div className="fspLoader">
                    <Loaders isLoading={isLoading} />
                </div>
            ) : valueLoaded ? (
                <div className="addUserModal addListing">
                    {Object.keys(formik.values).length !== 0 ? (
                        <>
                            <form
                                onSubmit={formik.handleSubmit}
                                autoComplete="nofill"
                            >
                                {props.customInBetween ? (
                                    <>
                                        {mapDataValue1?.length ? (
                                            <div className="row productNewCheck">
                                                {mapData({
                                                    formik,
                                                    data: mapDataValue1,
                                                })}
                                                {mapData({
                                                    formik,
                                                    data: serialHabanosField,
                                                })}
                                                <div className="col-auto">
                                                    <PrimaryButton
                                                        btnSize="checkSeriralButton"
                                                        id="serial_submit"
                                                        onClick={() => {
                                                            if (
                                                                formik?.values
                                                                    ?.serial_number
                                                            ) {
                                                                getSerialCheck({
                                                                    serialNumber:
                                                                        formik
                                                                            ?.values
                                                                            .serial_number,
                                                                    cigarId:
                                                                        formik
                                                                            .values
                                                                            .cigar_id,
                                                                })
                                                            } else {
                                                                setAlert(
                                                                    'Serial Number is required',
                                                                    'error'
                                                                )
                                                            }
                                                        }}
                                                        type="button"
                                                        label={'Check Serial'}
                                                    />
                                                </div>
                                            </div>
                                        ) : null}

                                        {mapDataValue2?.length ? (
                                            <div className="row productNewCheck">
                                                {mapData({
                                                    formik,
                                                    data: mapDataValue2,
                                                })}
                                            </div>
                                        ) : null}
                                    </>
                                ) : (
                                    <>
                                        {mapDataValue?.length ? (
                                            <div className="row">
                                                {mapData({
                                                    formik,
                                                    data: mapDataValue,
                                                })}
                                            </div>
                                        ) : null}
                                        {props.customDynamicInput ? (
                                            <>
                                                <div className="row">
                                                    <ItemPropsList
                                                        formik={formik}
                                                        trigger={
                                                            arrayItemTrigger
                                                        }
                                                        errors={
                                                            itemPropsArrayErrors
                                                        }
                                                        resetTrigger={
                                                            SetArrayItemTrigger
                                                        }
                                                        alldata_all_dropdown={
                                                            alldata_all_dropdown
                                                        }
                                                        allCountries={
                                                            allCountries
                                                        }
                                                        subStateOptions={
                                                            subStateOptions
                                                        }
                                                        subCityOptions={
                                                            subCityOptions
                                                        }
                                                        allLocations={
                                                            allLocations
                                                        }
                                                        isDelete={
                                                            props.isDelete
                                                        }
                                                    />
                                                </div>
                                                <div className="row">
                                                    <div className="col-12 moreBtnPRT">
                                                        <Button
                                                            className="addMore"
                                                            type="button"
                                                            onClick={() =>
                                                                onAddItemArrayHandle(
                                                                    1
                                                                )
                                                            }
                                                        >
                                                            <span className="material-icons">
                                                                add_circle
                                                            </span>
                                                            {t('Add Damage')}
                                                        </Button>
                                                    </div>
                                                </div>
                                            </>
                                        ) : null}
                                    </>
                                )}

                                <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                    <SecondaryButton
                                        id="baseAction_cancel"
                                        label="cancel"
                                        onClick={props.cancelFunction}
                                    />
                                    {props.buttonAction.map((data, index) => (
                                        <>
                                            {data.style === 'primary' ? (
                                                <>
                                                    <PrimaryButton
                                                        id="base_submit"
                                                        onClick={() => {
                                                            formSubmit(
                                                                data.type,
                                                                data.additionalValue
                                                            )
                                                        }}
                                                        type="button"
                                                        label={data.label}
                                                    />
                                                </>
                                            ) : data.style === 'secondary' ? (
                                                <SecondaryButton
                                                    id="baseAction_draft"
                                                    onClick={() => {
                                                        formSubmit(
                                                            data.type,
                                                            data.additionalValue
                                                        )
                                                    }}
                                                    type="button"
                                                    label={data.label}
                                                />
                                            ) : null}
                                        </>
                                    ))}
                                    {props?.editValue?.record?.id ? (
                                        props?.editValue?.record
                                            ?.market_status != 'sold' ? (
                                            props?.editValue?.record
                                                ?.market_status != 'unsold' ? (
                                                props?.editValue?.record
                                                    ?.market_status !=
                                                'closed' ? (
                                                    props?.editValue?.record
                                                        ?.market_status !=
                                                    'newTemplate' ? (
                                                        <PrimaryButton
                                                            id="auction_table_submit"
                                                            type="button"
                                                            label="Disapprove"
                                                            onClick={() =>
                                                                handleDisapproveBtn()
                                                            }
                                                        />
                                                    ) : null
                                                ) : null
                                            ) : null
                                        ) : null
                                    ) : null}
                                    {props?.editValue?.record?.id ? (
                                        props?.editValue?.record
                                            ?.market_status === 'draft' ? (
                                            props?.editValue?.record
                                                ?.escalate != 1 ? (
                                                <PrimaryButton
                                                    id="auction_table_submit"
                                                    type="button"
                                                    label="Escalate"
                                                    onClick={() => {
                                                        formikAddNotes.setFieldValue(
                                                            'project_id',
                                                            props?.editValue
                                                                ?.record?.id
                                                        )
                                                        handleEscalateBtn()
                                                    }}
                                                />
                                            ) : null
                                        ) : null
                                    ) : null}
                                </div>
                            </form>
                            {data?.status === 'edit' && props.changePassword ? (
                                <>
                                    <form
                                        onSubmit={
                                            props.empPassword
                                                ? props.formikEmpPassword
                                                      .handleSubmit
                                                : props.formikPassword
                                                      .handleSubmit
                                        }
                                        autoComplete="nofill"
                                    >
                                        <h2 className="dashTitle">
                                            CHANGE PASSWORD
                                        </h2>
                                        <div className="row">
                                            {mapData({
                                                formik: props.empPassword
                                                    ? props.formikEmpPassword
                                                    : props.formikPassword,
                                                data: props.empPassword
                                                    ? props.passwordEmpChange
                                                    : props.passwordChange,
                                            })}
                                        </div>
                                        <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                            <PrimaryButton
                                                id="employee_submit"
                                                type="submit"
                                                label="Submit"
                                            />
                                        </div>
                                    </form>
                                </>
                            ) : null}
                        </>
                    ) : null}
                    {/* {props?.editValue?.record?.id ? (
                        props?.editValue?.record?.market_status != 'sold' ? (
                            props?.editValue?.record?.market_status !=
                            'unsold' ? (
                                props?.editValue?.record?.market_status !=
                                'closed' ? (
                                    props?.editValue?.record?.market_status !=
                                    'newTemplate' ? (
                                        <>
                                            <div className="row">
                                                {mapData(disapprovalField)}
                                            </div>
                                            <form
                                                onSubmit={
                                                    formikApprovalSelection.handleSubmit
                                                }
                                                autoComplete="nofill"
                                            >
                                                <PrimaryButton
                                                    id="auction_table_submit"
                                                    type="submit"
                                                    label="Disapprove"
                                                />
                                            </form>
                                        </>
                                    ) : null
                                ) : null
                            ) : null
                        ) : null
                    ) : null} */}
                </div>
            ) : null}

            <CustomDialog
                title={t('Disapprove Listing')}
                open={disapStatus}
                function={handleDisapproveBtn}
                handleClose={handleDisapproveBtn}
                className="disapproveDialog"
            >
                <>
                    <div className="row">{mapData(disapprovalField)}</div>
                    <form
                        onSubmit={formikApprovalSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="auction_table_submit"
                            type="submit"
                            label="Disapprove"
                        />
                    </form>
                </>
            </CustomDialog>

            <CustomDialog
                title={t('Escalate Listing')}
                open={escalateStatus}
                function={handleEscalateBtn}
                handleClose={handleEscalateBtn}
                className="escalateDialog"
            >
                <>
                    <div className="row">{mapData(addNotesField)}</div>
                    <form
                        onSubmit={formikAddNotes.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="auction_table_submit"
                            type="submit"
                            label="Confirm Escalation"
                        />
                    </form>
                </>
            </CustomDialog>
            <CustomDialog
                title={t('Form_Validation')}
                open={toggleDialogErr}
                function={changeDialogStatusErr}
                handleClose={changeDialogStatusErr}
                className="validationErrorDialog"
            >
                <ol>
                    {errorArray.current.map((e) =>
                        e.label != ' ' ? (
                            <li>
                                {e.label}:<span>{e.errorVal}</span>
                            </li>
                        ) : null
                    )}
                </ol>
            </CustomDialog>

            <CustomDialog
                title="Check Serial – Habanos Validation"
                open={serialCheckDialog}
                function={handleSerialCheckCancel}
                handleClose={handleSerialCheckCancel}
                className="serialCheckDialog"
            >
                <div className="serialCheckContent">
                    <div className="mb-3">
                        <strong>Description:</strong>
                        <p>{serialCheckData?.Description || '—'}</p>
                    </div>
                    <div className="mb-3">
                        <strong>HSA:</strong>
                        <p>{serialCheckData?.HSA || '—'}</p>
                    </div>
                    <div
                        className="d-flex justify-content-center mt-3"
                        style={{ gap: '10px' }}
                    >
                        <PrimaryButton
                            id="serial_check_confirm"
                            type="button"
                            label="Confirm"
                            onClick={handleSerialCheckConfirm}
                        />
                        <SecondaryButton
                            id="serial_check_cancel"
                            label="Cancel"
                            onClick={handleSerialCheckCancel}
                        />
                    </div>
                </div>
            </CustomDialog>
        </>
    )
}

export default BaseActionPage
